import React from "react";
import { GiGuitarHead, GiMetronome, GiMusicalNotes } from "react-icons/gi";

interface BulletPointProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  icon: React.ReactNode;
}

function AboutBulletPoint({
  title,
  children,
  className,
  icon,
}: BulletPointProps) {
  return (
    <div
      className={`basis-[100%] flex flex-col items-center bg-primary lg:max-w-sm max-w-md  p-5 m-5 shadow-2xl rounded-3xl ${className}`}
    >
      <h3 className="pb-5 text-3xl xl:text-4xl font-bold text-center ">
        {title}
      </h3>
      <div className="lg:pb-10 lg:pt-5 scale-75 lg:scale-100">{icon}</div>
      <p className="text-xl text-center">{children}</p>
    </div>
  );
}

function About() {
  return (
    <div
      id="about"
      className="bg-background text-primary w-full py-10 md:pb-10 md:px-5 flex flex-col items-center "
    >
      <h1 className="text-6xl md:text-8xl pt-10 text-center">About this app</h1>
      <p className="text-center text-2xl p-10">
        PlayGuru is set up to have several categories of exercises and tools.{" "}
        <br />
        Below are some of the most important highlighted.
      </p>
      <div className="flex lg:flex-row flex-col justify-evenly">
        <AboutBulletPoint
          title="Melodic Dictation"
          className="bg-gradient-to-b from-green-600 to-green-800"
          icon={<GiMusicalNotes size={200} />}
        >
          Train your melodic memory by playing an increasingly long melody. The
          Guru will increment the difficulty as you go!
        </AboutBulletPoint>
        <AboutBulletPoint
          title="Rhythms"
          className="bg-gradient-to-b from-purple-500 to-purple-700"
          icon={<GiMetronome size={200} />}
        >
          Play the rhythms provided by the Guru. When you've completed the four
          rhythms, the tempo increases!
        </AboutBulletPoint>
        <AboutBulletPoint
          title="Tuner"
          className="bg-gradient-to-b from-pink-600 to-pink-800"
          icon={<GiGuitarHead size={200} />}
        >
          Tuning your guitar is essential for practicing. With the tuner
          provided in PlayGuru you'll never have to leave the app!
        </AboutBulletPoint>
      </div>
    </div>
  );
}

export default About;
